import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import SelectFilter from "./components/SelectFilter";
import * as CONSTANTS from "../constants";
import "./style.css";

const TabFilter = ({ store, languageContext, setFilter, setSortBy, state }) => (
  <BaseGrid childWidth="auto">
    <SelectFilter
      name={languageContext("status")}
      options={CONSTANTS.SORT_OPTIONS_STATUS}
      value={store.filter.filter.toLowerCase()}
      onChange={setFilter}
      languageContext={languageContext}
      className="filter-select"
      translateOptions={true}
    />
    <SelectFilter
      name={languageContext("sort")}
      options={CONSTANTS.SORT_OPTIONS_ORDER}
      value={state.sortBy}
      onChange={setSortBy}
      languageContext={languageContext}
      className="filter-select"
      translateOptions={true}
    />
  </BaseGrid>
);

export default TabFilter;
